export default "__VITE_ASSET__CLDyDZE9__"